import Seo from '../components/Seo.jsx';
import Button from '../components/ui/Button.jsx';

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found" path="/404" noindex />
      <section className="flex min-h-[60vh] items-center py-20">
        <div className="wrap text-center">
          <p className="eyebrow mb-3">Error 404</p>
          <h1 className="mb-4 font-display text-[28px] font-bold text-deep lg:text-[36px]">
            That page isn&rsquo;t here.
          </h1>
          <p className="mx-auto mb-8 max-w-[420px] text-[15px] text-muted">
            The link may be out of date. Everything about Chickrah is on the home page, or we can
            walk you through it directly.
          </p>
          <div className="flex flex-wrap justify-center gap-3.5">
            <Button to="/" variant="dark">
              Back to home
            </Button>
            <Button to="/demo" variant="primary">
              Book a demo
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}
